import { Component, Input, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-modal-pdf',
  standalone: true,
  imports: [],
  templateUrl: './modal-pdf.component.html',
  styleUrl: './modal-pdf.component.scss',
})
export class ModalPdfComponent implements OnInit, OnDestroy {
  @Input() pdf!: Blob;
  @Input() pdfTitle: string = 'Schedule Of Benefits';

  pdfUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    if (this.pdf) {
      this.showPdf();
    }
  }

  ngOnDestroy() {
    if (this.pdfUrl) {
      const urlString = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.pdfUrl);
      if (urlString) {
        const url = urlString.split('#')[0];
        window.URL.revokeObjectURL(url);
      }
    }
  }

  showPdf() {
    const filename = `${this.pdfTitle}.pdf`;
    const file = new File([this.pdf], filename, { type: 'application/pdf' });

    const url = window.URL.createObjectURL(file);
    const urlWithParams = `${url}#zoom=125%&view=FitH&title=${encodeURIComponent(this.pdfTitle)}`;
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);
  }
}
